import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { MemberResponse } from "../contracts/MemberResponse";
import { MemberResponseMapper } from "../mappers/MemberResponseMapper";
import { Member } from "../models/Member";

const memberMapper = new MemberResponseMapper();

/**
 * Stops or allows a member's messages in the organization (US-111, PD-0054). The member keeps their
 * lessons, money and library; the who and when are recorded on the member.
 */
export const setMemberMessagesStopped = createAsyncThunk<
  Member,
  { memberId: string; stopped: boolean },
  { rejectValue: ApiErrorResponse }
>("members/setMessagesStopped", async ({ memberId, stopped }, { rejectWithValue }) => {
  try {
    const url = `/members/${memberId}/messages-stop`;
    const { data } = stopped
      ? await axiosInstance.post<MemberResponse>(url)
      : await axiosInstance.delete<MemberResponse>(url);
    return memberMapper.toMember(data);
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to change the member's messages"));
  }
});
